import { styled, keyframes } from 'styled-components'
import { m } from 'motion/react'
import { IconWrapper } from '../buttons.styles'

const BADGE_SIZE = 16

const hop = keyframes`
  0%, 100% { transform: translateY(0) scale(1); }
  35% { transform: translateY(-4px) scale(1.15, 0.9); }
  55% { transform: translateY(0) scale(0.92, 1.08); }
  75% { transform: translateY(-1px) scale(1.04); }
`

const ripple = keyframes`
  0% { transform: scale(1); opacity: 0.55; }
  100% { transform: scale(2.2); opacity: 0; }
`

// Motion owns this element's transform (entrance + count pop), so the CSS
// hover animation lives on the inner Bubble to avoid fighting over it.
export const Badge = styled(m.span)`
  position: absolute;
  right: -0.5px;
  bottom: -0.5px;
  pointer-events: none;
`

export const Bubble = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${BADGE_SIZE}px;
  height: ${BADGE_SIZE}px;
  padding: 0 4px;
  box-sizing: border-box;
  border-radius: ${BADGE_SIZE / 2}px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  isolation: isolate;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background-color: ${({ theme }) => theme.colors.primary};
    opacity: 0;
    z-index: -1;
  }

  @media (hover: hover) and (prefers-reduced-motion: no-preference) {
    *:hover > ${IconWrapper} & {
      animation: ${hop} 0.6s cubic-bezier(0.3, 0.7, 0.4, 1);
    }

    *:hover > ${IconWrapper} &::after {
      animation: ${ripple} 0.7s ease-out;
    }
  }
`

export const CountClip = styled.span`
  display: flex;
  height: 100%;
  align-items: center;
  overflow: hidden;
`

export const Count = styled(m.span)`
  display: block;
`
